import React, { useEffect, useState } from "react";
import { AzureAD, LoginType, AuthenticationState } from "react-aad-msal";
import InlineLoader from "../../elements/inline-loader";

import store from "../../redux/store/store";
import { authProvider } from "../../services/authProvider";
import { canUseDOM } from "../../utils";

const SampleAppRedirectOnLaunch = () => {
  const [counter, setCounter] = useState(0);
  const [interval, setInterval] = useState(0);

  const [redirectEnabled, setRedirectEnabled] = useState(
    sessionStorage.getItem("redirectEnabled") || false
  );

  const countdownToLogin = loginFunction => {
    if (redirectEnabled && !interval) {
      setInterval(() => {
        if (counter > 0) {
          setCounter(counter - 1);
        } else {
          clearRedirectInterval();
          setRedirectEnabled(false);
          loginFunction();
        }
      }, 1000);
    }
  };

  const clearRedirectInterval = () => {
    clearInterval(interval);

    setCounter(5);
    sessionStorage.removeItem("redirectEnabled");
    setInterval(null);
  };

  useEffect(() => {
    const options = authProvider.getProviderOptions();
    options.loginType = LoginType.Redirect;
    authProvider.setProviderOptions(options);

    setRedirectEnabled(true);
  }, []);

  useEffect(() => {
    if (!redirectEnabled) {
      clearRedirectInterval();
    } else {
      sessionStorage.setItem("redirectEnabled", true);
    }
  }, [redirectEnabled]);

  if (!canUseDOM()) return null;
  return (
    <AzureAD provider={authProvider} reduxStore={store}>
      {({ login, authenticationState }) => {
        const isInProgress =
          authenticationState === AuthenticationState.InProgress;
        const isUnauthenticated =
          authenticationState === AuthenticationState.Unauthenticated;

        if (isUnauthenticated || isInProgress) {
          countdownToLogin(login);
          return (
            <>
              {redirectEnabled && (
                <>
                  <InlineLoader />
                  <p>Redirecting in {counter} seconds...</p>
                </>
              )}
            </>
          );
        }
      }}
    </AzureAD>
  );
};

export default SampleAppRedirectOnLaunch;
